/**
 * Logs an error to the `error_logs` table so admins can see it in the dashboard.
 * Fail-silent — never throws, never blocks the UI.
 */
import { supabase } from '@/integrations/supabase/client';

export async function logError(
  context: string,
  error: unknown,
  details?: Record<string, unknown>
): Promise<void> {
  try {
    const errorMessage =
      error instanceof Error ? error.message : typeof error === 'string' ? error : JSON.stringify(error);

    const errorDetails: Record<string, unknown> = { ...(details || {}) };
    if (error instanceof Error && error.stack) errorDetails.stack = error.stack;

    const { data: { user } } = await supabase.auth.getUser();
    if (!user?.id) return; // RLS requires an authenticated user_id

    await supabase.from('error_logs').insert({
      user_id: user.id,
      context,
      error_message: errorMessage.slice(0, 2000),
      error_details: errorDetails as any,
      url: typeof window !== 'undefined' ? window.location.href : undefined,
      user_agent: typeof navigator !== 'undefined' ? navigator.userAgent : undefined,
    });
  } catch (e) {
    // Never let logging break the app
    console.warn('[errorLogger] failed to log error', e);
  }
}